import { allPlaylistTopics } from './allTopics';
import { allPlaylistCreativeFields } from './allCreativeFields';

export const BASE_ERROR_MESSAGE = 'LCP';
export const BACKEND_ERROR_MESSAGE = 'LCP SERVICE FAILURE';
export const DEFAULT_LOCALE = 'en_US';
export const APP_ROOT_URI = '/cc/lcp';
export const TAGGER_VIEW = 'tag';
export const CURATE_VIEW = 'curate';
export const USER_PROFILE_VIEW = 'user-profile';
export const AUTH_ERROR_CODE = 401;
//local storage keys
export const LOCAL_STORAGE_OID_KEY = 'oidlist';
export const LOCAL_STORAGE_ARTICLE_LOAD_TIME_KEY = 'article-load-time';
export const SESSION_STORAGE_SHOW_ML_ALERT_KEY = 'show-ml-alert';
export const SESSION_STORAGE_ACCEPT_ML_ALERT_KEY = 'mltag-alert-accept';
//session storage keys
export const SESSION_STORAGE_USER_ROLE = 'user-role';
export const SESSION_STORAGE_DISABLE_SAVE_DLG = 'disable-save-dlg';
export const SESSION_STORAGE_DISABLE_REMOVE_TAG_DLG = 'disable-rmv-tag-dlg';
//environments
export const IMS_STAGE_ENV = 'stg1';

export const AEM_ID_CHARACTER_LIMIT = 150;

export const REQUEST_STATUS = {
    INITIATED: 'Initiated',
    SUCCESS: 'Success',
    FAILED: 'Failed',
};

//MLTagsShownPerCategory
export const ML_TAGS_SHOWN_PER_CATEGORY = 5;

export const languageList = [
    {
        label: 'Czech',
        value: 'cs_CZ',
    },
    {
        label: 'Danish',
        value: 'da_DK',
    },
    {
        label: 'German',
        value: 'de_DE',
    },
    {
        label: 'English',
        value: 'en_US',
    },
    {
        label: 'Spanish',
        value: 'es_ES',
    },
    {
        label: 'Finnish',
        value: 'fi_FI',
    },
    {
        label: 'French',
        value: 'fr_FR',
    },
    {
        label: 'Hungarian',
        value: 'hu_HU',
    },
    {
        label: 'Indonesian',
        value: 'id_ID',
    },
    {
        label: 'Italian',
        value: 'it_IT',
    },
    {
        label: 'Japanese',
        value: 'ja_JP',
    },
    {
        label: 'Korean',
        value: 'ko_KR',
    },
    {
        label: 'Norwegian',
        value: 'nb_NO',
    },
    {
        label: 'Dutch',
        value: 'nl_NL',
    },
    {
        label: 'Polish',
        value: 'pl_PL',
    },
    {
        label: 'Portuguese',
        value: 'pt_BR',
    },
    {
        label: 'Russian',
        value: 'ru_RU',
    },
    {
        label: 'Swedish',
        value: 'sv_SE',
    },
    {
        label: 'Thai',
        value: 'th_TH',
    },
    {
        label: 'Turkish',
        value: 'tr_TR',
    },
    {
        label: 'Ukrainian',
        value: 'uk_UA',
    },
    {
        label: 'Vietnamese',
        value: 'vi_VN',
    },
    {
        label: 'Simplified Chinese',
        value: 'zh_CN',
    },
    {
        label: 'Traditional Chinese',
        value: 'zh_TW',
    },
];

export const allLocaleCodes = languageList.map((lang) => lang.value);

export const ELEMENT_TYPES = {
    TUTORIAL: 'tutorial',
    PLAYLIST: 'playlist',
    COLLECTION: 'collection',
};

export const thumbnailPaddedWidth = 50;

export const columnsUtutsDashboard = [
    {
        name: 'lcp.common.table.thumbnail',
        key: 'THUMBNAIL',
        width: 40,
        align: 'left',
    },
    {
        name: 'lcp.common.table.title',
        key: 'TITLE',
        minWidth: 120,
        align: 'left',
        allowsSorting: true,
    },
    {
        name: 'lcp.common.table.icon',
        key: 'ICON',
        width: 40,
        align: 'left',
        divider: true,
    },
    {
        name: 'lcp.common.table.aemId',
        key: 'AEMID',
        minWidth: 120,
        align: 'left',
        allowsSorting: true,
    },
    {
        name: 'lcp.common.table.copy',
        key: 'COPY',
        width: 60,
        align: 'left',
        divider: false,
    },
    {
        name: 'lcp.common.table.app',
        key: 'APPCODE',
        minWidth: 120,
        align: 'left',
    },
    {
        name: 'lcp.common.table.surface',
        key: 'SURFACE',
        minWidth: 130,
        align: 'left',
    },
    {
        name: 'lcp.common.table.status',
        key: 'STATUS',
        minWidth: 70,
        align: 'left',
    },
    {
        name: 'lcp.common.table.lastModified',
        key: 'MODIFIEDON',
        minWidth: 120,
        align: 'left',
        allowsSorting: true,
    },
    {
        name: 'lcp.common.table.preview',
        key: 'PREVIEW',
        align: 'left',
        minWidth: 80,
    },
];
export const columnsUtutsInPlaylistView = [
    {
        name: 'lcp.common.table.order',
        title: '',
        key: 'ORDER',
        width: 85,
        align: 'left',
    },
    {
        name: 'lcp.common.table.thumbnail',
        title: '',
        key: 'THUMBNAIL',
        width: 40,
        align: 'left',
    },
    {
        name: 'lcp.common.table.title',
        title: 'TITLE',
        key: 'TITLE',
        minWidth: 120,
        align: 'left',
    },
    {
        name: 'lcp.common.table.icon',
        title: '',
        key: 'ICON',
        width: 40,
        align: 'left',
        divider: true,
    },
    {
        name: 'lcp.common.table.aemId',
        title: 'AEM ID',
        key: 'AEMID',
        minWidth: 120,
        align: 'left',
    },
    {
        name: 'lcp.common.table.app',
        title: 'APP',
        key: 'APPCODE',
        minWidth: 120,
        align: 'left',
    },
    {
        name: 'lcp.common.table.surface',
        title: 'SURFACE',
        key: 'SURFACE',
        minWidth: 130,
        align: 'left',
    },
    {
        name: 'lcp.common.table.status',
        title: 'STATUS',
        key: 'STATUS',
        minWidth: 85,
        align: 'left',
    },
    {
        name: 'lcp.common.table.lastModified',
        title: 'LAST MODIFIED',
        key: 'MODIFIEDON',
        minWidth: 120,
        align: 'left',
    },
    {
        name: 'lcp.common.table.preview',
        title: 'PREVIEW',
        key: 'PREVIEW',
        align: 'left',
        minWidth: 80,
    },
];

export const columnsPlaylistsInCLView = [
    {
        name: 'lcp.common.table.order',
        title: '',
        key: 'ORDER',
        width: 85,
        align: 'left',
    },
    {
        name: 'lcp.common.table.thumbnail',
        title: '',
        key: 'THUMBNAIL',
        width: 40,
        align: 'left',
    },
    {
        name: 'lcp.common.table.title',
        title: 'TITLE',
        key: 'TITLE',
        minWidth: 120,
        align: 'left',
    },
    {
        name: 'lcp.common.table.icon',
        title: '',
        key: 'ICON',
        width: 40,
        align: 'left',
        divider: true,
    },
    {
        name: 'lcp.common.table.aemId',
        title: 'AEM ID',
        key: 'AEMID',
        minWidth: 120,
        align: 'left',
    },
    {
        name: 'lcp.common.table.app',
        title: 'APP',
        key: 'APPCODE',
        minWidth: 120,
        align: 'left',
    },
    {
        name: 'lcp.common.table.surface',
        title: 'SURFACE',
        key: 'SURFACE',
        minWidth: 130,
        align: 'left',
    },
    {
        name: 'lcp.common.table.status',
        title: 'STATUS',
        key: 'STATUS',
        minWidth: 85,
        align: 'left',
    },
    {
        name: 'lcp.common.table.stage',
        title: 'STAGE',
        key: 'STAGE',
        minWidth: 120,
        align: 'left',
    },
    {
        name: 'lcp.common.table.lastModified',
        title: 'LAST MODIFIED',
        key: 'MODIFIEDON',
        minWidth: 120,
        align: 'left',
    },
    {
        name: 'lcp.common.table.preview',
        title: 'PREVIEW',
        key: 'PREVIEW',
        align: 'left',
        minWidth: 80,
    },
];

export const columnsPlaylistDashboard = [
    {
        name: 'lcp.common.table.thumbnail',
        key: 'THUMBNAIL',
        width: 40,
        align: 'left',
    },
    {
        name: 'lcp.common.table.title',
        key: 'TITLE',
        minWidth: 120,
        align: 'left',
        allowsSorting: true,
    },
    {
        name: 'lcp.common.table.editIcon',
        key: 'EDITICON',
        width: 40,
        align: 'left',
    },
    {
        name: 'lcp.common.table.icon',
        key: 'ICON',
        width: 40,
        align: 'left',
        divider: true,
    },
    {
        name: 'lcp.common.table.aemId',
        key: 'AEMID',
        minWidth: 120,
        align: 'left',
        allowsSorting: true,
    },
    {
        name: 'lcp.common.table.copy',
        key: 'COPY',
        width: 40,
        align: 'left',
        divider: false,
    },
    {
        name: 'lcp.common.table.collections',
        key: 'COLLECTIONS',
        minWidth: 50,
        align: 'left',
    },
    {
        name: 'lcp.common.table.app',
        key: 'APPCODE',
        minWidth: 120,
        align: 'left',
    },
    {
        name: 'lcp.common.table.surface',
        key: 'SURFACE',
        minWidth: 95,
        align: 'left',
    },
    {
        name: 'lcp.common.table.status',
        key: 'STATUS',
        minWidth: 85,
        align: 'left',
    },
    {
        name: 'lcp.common.table.stage',
        key: 'STAGE',
        minWidth: 100,
        align: 'left',
    },
    {
        name: 'lcp.common.table.lastModified',
        key: 'MODIFIEDON',
        minWidth: 120,
        align: 'left',
        allowsSorting: true,
    },
];

export const columnsCL = [
    {
        name: 'lcp.common.table.thumbnail',
        key: 'THUMBNAIL',
        width: 40,
        align: 'left',
    },
    {
        name: 'lcp.common.table.title',
        key: 'TITLE',
        minWidth: 120,
        align: 'left',
        allowsSorting: true,
    },
    {
        name: 'lcp.common.table.editIcon',
        key: 'EDITICON',
        width: 40,
        align: 'left',
    },
    {
        name: 'lcp.common.table.icon',
        key: 'ICON',
        width: 40,
        align: 'left',
        divider: true,
    },
    {
        name: 'lcp.common.table.aemId',
        key: 'AEMID',
        minWidth: 120,
        align: 'left',
        allowsSorting: true,
    },
    {
        name: 'lcp.common.table.copy',
        key: 'COPY',
        width: 40,
        align: 'left',
        divider: false,
    },
    {
        name: 'lcp.common.table.app',
        key: 'APPCODE',
        minWidth: 120,
        align: 'left',
    },
    {
        name: 'lcp.common.table.status',
        key: 'STATUS',
        minWidth: 70,
        align: 'left',
    },
    {
        name: 'lcp.common.table.stage',
        key: 'STAGE',
        minWidth: 100,
        align: 'left',
    },
    {
        name: 'lcp.common.table.lastModified',
        key: 'MODIFIEDON',
        minWidth: 120,
        align: 'left',
        allowsSorting: true,
    },
];

export const appList = [
    {
        label: 'lcp.common.allApps',
        value: 'all',
    },
    {
        label: 'Acrobat DC',
        value: 'ACRS',
    },

    {
        label: 'Aero',
        value: 'AERO',
    },
    {
        label: 'After Effects',
        value: 'AEFT',
    },
    {
        label: 'Animate',
        value: 'FLPR',
    },
    {
        label: 'Audition',
        value: 'AUDT',
    },
    {
        label: 'Bridge',
        value: 'KBRG',
    },
    {
        label: 'Camera Raw',
        value: 'ACR',
    },
    {
        label: 'Character Animator',
        value: 'ANML',
    },
    {
        label: 'Creative Cloud',
        value: 'CCSN',
    },

    {
        label: 'Dimension',
        value: 'ESHR',
    },

    {
        label: 'Dreamweaver',
        value: 'DRWV',
    },

    {
        label: 'Express',
        value: 'CCEX',
    },

    {
        label: 'Firefly',
        value: 'FFLY',
    },

    {
        label: 'Fonts',
        value: 'TKIT',
    },

    {
        label: 'Fresco',
        value: 'FRSC',
    },
    {
        label: 'Illustrator',
        value: 'ILST',
    },
    {
        label: 'InDesign',
        value: 'IDSN',
    },
    {
        label: 'Media Encoder',
        value: 'AME',
    },

    {
        label: 'Photoshop Camera',
        value: 'PCAM',
    },

    {
        label: 'Photoshop Express',
        value: 'PSX',
    },
    {
        label: 'Premiere Pro',
        value: 'PPRO',
    },

    {
        label: 'Lightroom',
        value: 'LPES',
    },

    {
        label: 'Lightroom Classic',
        value: 'LTRM',
    },
    {
        label: 'Photoshop',
        value: 'PHSP',
    },
    {
        label: 'Premiere Rush',
        value: 'RUSH',
    },
    {
        label: 'SpeedGrade',
        value: 'SPGD',
    },
    {
        label: 'Stock',
        value: 'STOK',
    },

    {
        label: 'Substance 3D Designer',
        value: 'SBSTD',
    },

    {
        label: 'Substance 3D Modeler',
        value: 'SHPR',
    },

    {
        label: 'Substance 3D Painter',
        value: 'SBSTP',
    },

    {
        label: 'Substance 3D Sampler',
        value: 'SBSTA',
    },

    {
        label: 'Substance 3D Stager',
        value: 'STGR',
    },

    {
        label: 'XD',
        value: 'SPRK',
    },
];

export const appLookUp = {
    PHSP: 'Photoshop',
    ILST: 'Illustrator',
    IDSN: 'InDesign',
    AERO: 'Aero',
    PPRO: 'Premiere Pro',
    AEFT: 'After Effects',
    FLPR: 'Animate',
    AUDT: 'Audition',
    KBRG: 'Bridge',
    ACR: 'Camera Raw',
    ANML: 'Character Animator',
    CCSN: 'Creative Cloud',
    ESHR: 'Dimension',
    DRWV: 'Dreamweaver',
    TKIT: 'Fonts',
    FRSC: 'Fresco',
    AME: 'Media Encoder',
    PCAM: 'Photoshop Camera',
    PSX: 'Photoshop Express',
    LPES: 'Lightroom',
    LTRM: 'Lightroom Classic',
    RUSH: 'Premiere Rush',
    SPGD: 'SpeedGrade',
    STOK: 'Stock',
    SBST: 'Substance',
    SBSTD: 'Substance 3D Designer',
    SHPR: 'Substance 3D Modeler',
    SBSTP: 'Substance 3D Painter',
    SBSTA: 'Substance 3D Sampler',
    STGR: 'Substance 3D Stager',
    SPRK: 'XD',
    ACRS: 'Acrobat DC',
    CCEX: 'Express',
    FFLY: 'Firefly',
};

export const appLookUpSG = {
    ACRS: 'SG_ACROBAT_DC',
    AEFT: 'SG_AFTEREFFECTS_1_1',
    ILST: 'SG_ILLUSTRATOR_1_1',
    IDSN: 'SG_INDESIGN_1_1',
    PSW: 'SG_PHOTOSHOP_WEB',
    PHSP: 'SG_PHOTOSHOP_1_1',
    PPRO: 'SG_PREMIEREPRO_1_1',
    CCEX: 'SG_CC_EXPRESS',
    FFLY: 'SG_FIREFLY',
    LPES: 'SG_LIGHTROOM_1_1_cc',
    LTRM: 'SG_LIGHTROOM_1_1_classic',
    SBSTA: 'SG_SUBSTANCE_SAMPLER',
    SBSTD: 'SG_SUBSTANCE_DESIGNER',
    SBSTP: 'SG_SUBSTANCE_PAINTER',
    SHPR: 'SG_SUBSTANCE_3D_MODELER',
    STGR: 'SG_SUBSTANCE_3D_STAGER',
};

export const surfaceListUtut = [
    {
        label: 'lcp.common.allSurfaces',
        value: 'all',
    },
    {
        label: 'Discover',
        value: 'discover',
    },
    {
        label: 'In-App',
        value: 'in-app',
    },
    {
        label: 'Helpx',
        value: 'helpx',
    },
    {
        label: 'Education',
        value: 'education',
    },
    {
        label: 'Help_Using',
        value: 'help_using',
    },
    {
        label: 'Help_KB',
        value: 'help_kb',
    },
    {
        label: 'Video-Only',
        value: 'video-only',
    },
];

export const surfaceListPL = [
    {
        label: 'lcp.common.allSurfaces',
        value: 'all',
    },
    {
        label: 'In-App',
        value: 'in-app',
    },
    {
        label: 'Helpx',
        value: 'helpx',
    },
    {
        label: 'Education',
        value: 'education',
    },
];

export const statusList = [
    {
        label: 'lcp.common.all',
        value: 'all',
    },
    {
        label: 'Draft',
        value: 'draft',
    },
    {
        label: 'Live',
        value: 'live',
    },
    {
        label: 'Archived',
        value: 'archived',
    },
];

export const statusListPL = [
    {
        label: 'lcp.common.all',
        value: 'all',
    },
    {
        label: 'Draft',
        value: 'draft',
    },
    {
        label: 'Live',
        value: 'live',
    },
];

export const stageListPL = [
    {
        label: 'lcp.common.all',
        value: 'all',
    },
    {
        label: '-',
        value: 'none',
    },
    {
        label: 'New - in progress',
        value: 'New - in progress',
    },
    {
        label: 'New - production ready',
        value: 'New - production ready',
    },
    {
        label: 'Update - in progress',
        value: 'Update - in progress',
    },
    {
        label: 'Update - production ready',
        value: 'Update - production ready',
    },
    {
        label: 'Future update',
        value: 'Future update',
    },
    {
        label: 'Request - archive',
        value: 'Request - archive',
    },
    {
        label: 'Archived',
        value: 'Archived',
    },
    {
        label: 'Deployed',
        value: 'Deployed',
    },
];

export const stageListCL = [
    {
        label: 'lcp.common.all',
        value: 'all',
    },
    {
        label: '-',
        value: 'none',
    },
    {
        label: 'New - in progress',
        value: 'New - in progress',
    },
    {
        label: 'New - production ready',
        value: 'New - production ready',
    },
    {
        label: 'Update - in progress',
        value: 'Update - in progress',
    },
    {
        label: 'Update - production ready',
        value: 'Update - production ready',
    },
    {
        label: 'Future update',
        value: 'Future update',
    },
    {
        label: 'Request - archive',
        value: 'Request - archive',
    },
    {
        label: 'Archived',
        value: 'Archived',
    },
    {
        label: 'Deployed',
        value: 'Deployed',
    },
];

export const column = [
    {
        name: 'THUMBNAIL',
        key: 'THUMBNAIL',
        minWidth: 45,
        maxWidth: 50,
        align: 'left',
    },
    {
        name: 'TITLE',
        key: 'TITLE',
        minWidth: 150,
        align: 'left',
    },
    {
        name: 'ICON',
        key: 'ICON',
        minWidth: 60,
        align: 'left',
        divider: true,
    },
    {
        name: 'AEM ID',
        key: 'aem_id',
        minWidth: 200,
        align: 'left',
    },
    {
        name: 'APP',
        key: 'APPCODE',
        minWidth: 50,
        maxWidth: 50,
        align: 'left',
    },
    {
        name: 'SURFACE',
        key: 'SURFACE',
        minWidth: 50,
        maxWidth: 50,
        align: 'left',
    },
    {
        name: 'LAST MODIFIED',
        key: 'MODIFIEDON',
        minWidth: 100,
        maxWidth: 100,
        align: 'left',
    },
    {
        name: 'PREVIEW',
        key: 'PREVIEW',
        align: 'left',
        minWidth: 50,
        maxWidth: 50,
    },
];

export const SURFACENAME = 'Surface';
export const APPNAME = 'App';
export const LANGUAGENAME = 'Language';
export const STATUSNAME = 'Status';
export const STAGENAME = 'Stage';
export const UTUTPAGE = 'UTUTPAGE';
export const PLAYLISTPAGE = 'PLAYLISTPAGE';
export const COLLECTIONPAGE = 'COLLECTIONPAGE';
export const LOCALENAME = 'Locale';

export const SORT_BY = 'Sort by';

// There are currently no plans to localize Content Production, so not localizing these strings
export const SORT_OPTIONS = [
    { value: 'title.keyword.asc', label: 'Title (asc)' },
    { value: 'title.keyword.desc', label: 'Title (desc)' },
    { value: 'modified_on.asc', label: 'Last modified (asc)' },
    { value: 'modified_on.desc', label: 'Last modified (desc)' },
    { value: 'created_on.asc', label: 'Created (asc)' },
    { value: 'created_on.desc', label: 'Created (desc)' },
    { value: 'aem_id.keyword.asc', label: 'AEM ID (asc)' },
    { value: 'aem_id.keyword.desc', label: 'AEM ID (desc)' },
];

export const VIEW_TYPE_TABLE = 'table_view';
export const VIEW_TYPE_GRID = 'grid_view';

export const TUTORIAL_LANGUAGE = 'Tutorial language';
export const UI_LANGUAGE = 'UI Language';
export const AUTHORIZATIONEMAIL = 'lcpauthorization@adobe.com';

export const PL_CREATION_LEARN_STAGE = [
    { id: '101', name: '101' },
    { id: '201', name: '201' },
    { id: '301', name: '301' },
];

export const PL_CREATION_PLAYLIST_STAGE = [
    { id: 'None', name: '-' },
    { id: 'New - in progress', name: 'New - in progress' },
    { id: 'New - production ready', name: 'New - production ready' },
    { id: 'Update - in progress', name: 'Update - in progress' },
    { id: 'Update - production ready', name: 'Update - production ready' },
    { id: 'Future update', name: 'Future update' },
    { id: 'Request - archive', name: 'Request - archive' },
    { id: 'Archived', name: 'Archived' },
    { id: 'Deployed', name: 'Deployed' },
];

export const PL_CREATION_COLLECTION_STAGE = [
    { id: 'None', name: '-' },
    { id: 'New - in progress', name: 'New - in progress' },
    { id: 'New - production ready', name: 'New - production ready' },
    { id: 'Update - in progress', name: 'Update - in progress' },
    { id: 'Update - production ready', name: 'Update - production ready' },
    { id: 'Future update', name: 'Future update' },
    { id: 'Request - archive', name: 'Request - archive' },
    { id: 'Archived', name: 'Archived' },
    { id: 'Deployed', name: 'Deployed' },
];

export const PL_CREATION_PRIMARY_PRODUCT = [
    { id: 'ACRS', name: 'Acrobat' },
    { id: 'AEFT', name: 'After Effects' },
    { id: 'ILST', name: 'Illustrator' },
    { id: 'IDSN', name: 'InDesign' },
    { id: 'PHSP', name: 'Photoshop' },
    { id: 'PPRO', name: 'Premiere Pro' },
    { id: 'CCEX', name: 'Express' },
    { id: 'FFLY', name: 'Firefly' },
    { id: 'LPES', name: 'Lightroom' },
    { id: 'LTRM', name: 'Lightroom Classic' },
    { id: 'SBSTD', name: 'Substance 3D Designer' },
    { id: 'SHPR', name: 'Substance 3D Modeler' },
    { id: 'SBSTP', name: 'Substance 3D Painter' },
    { id: 'SBSTA', name: 'Substance 3D Sampler' },
    { id: 'STGR', name: 'Substance 3D Stager' },
];

export const PL_CREATION_STATUS_ADMIN = [
    { id: 'draft', name: 'Draft' },
    { id: 'live', name: 'Live' },
];

export const PL_CREATION_STATUS_CURATOR = [{ id: 'draft', name: 'Draft' }];

export const PL_CREATION_TYPE = [
    { id: 'learn-on-the-web', name: 'learn-on-the-web' },
    { id: 'get-started', name: 'get-started' },
    { id: 'fundamentals', name: 'fundamentals' },
    { id: 'key-topics', name: 'key-topics' },
    { id: 'get-inspired', name: 'get-inspired' },
    { id: 'skills-and-projects', name: 'skills-and-projects' },
    { id: 'the-basics', name: 'the-basics' },
    { id: 'start-here', name: 'start-here' },
];

export enum LOCALE_SHORTCODE {
    ar_SA,
    bg_BG,
    bn_IN,
    cs_CZ,
    cy_GB,
    da_DK,
    de_DE,
    el_GR,
    en_US,
    es_ES,
    et_EE,
    fi_FI,
    fil_PH,
    fr_FR,
    he_IL,
    hr_HR,
    hu_HU,
    hi_IN,
    id_ID,
    it_IT,
    ja_JP,
    ko_KR,
    lt_LT,
    lv_LV,
    mar_IN,
    ms_MY,
    nb_NO,
    ne_NP,
    nl_NL,
    pl_PL,
    pt_BR,
    ro_RO,
    ru_RU,
    sk_SK,
    sr_BA,
    sv_SE,
    ta_IN,
    tel_IN,
    th_TH,
    tr_TR,
    uk_UA,
    vi_VN,
    zh_CN,
    zh_TW,
}

// Baby geo locales added for https://jira.corp.adobe.com/browse/LCP-786
// As per the requirements, this list is derived from https://wiki.corp.adobe.com/pages/viewpage.action?spaceKey=CCEE&title=Utut+service+Parent+and+Baby+Geo+list
// For the time being it is only supposed to be used as an additional locale filter for the CP Ututs dashboard, and only visible for CP Admin roles
export enum BABY_LOCALE {
    en_ZA,
    en_AU,
    en_BE,
    en_CA,
    en_GR,
    en_HK,
    en_IE,
    en_IL,
    en_IN,
    en_LU,
    en_MENA,
    en_NZ,
    en_UK,
    en_AE,
    en_SA,
    en_SG,
    en_TH,
    en_PH,
    en_ID,
    en_MY,
    en_VN,
    nl_BE,
    pt,
    zh_HK,
    fr_BE,
    fr_CA,
    fr_CH,
    fr_LU,
    de_AT,
    de_CH,
    de_LU,
    it_CH,
    es_LA,
    es_MX,
    es_CL,
    es_AR,
    es_PE,
    es_CO,
}

export const BABY_LOCALE_PARENT_MAPPING = new Map<LOCALE_SHORTCODE, BABY_LOCALE[]>([
    [
        LOCALE_SHORTCODE.en_US,
        [
            BABY_LOCALE.en_ZA,
            BABY_LOCALE.en_AU,
            BABY_LOCALE.en_BE,
            BABY_LOCALE.en_CA,
            BABY_LOCALE.en_GR,
            BABY_LOCALE.en_HK,
            BABY_LOCALE.en_IE,
            BABY_LOCALE.en_IL,
            BABY_LOCALE.en_IN,
            BABY_LOCALE.en_LU,
            BABY_LOCALE.en_MENA,
            BABY_LOCALE.en_NZ,
            BABY_LOCALE.en_UK,
            BABY_LOCALE.en_AE,
            BABY_LOCALE.en_SA,
            BABY_LOCALE.en_SG,
            BABY_LOCALE.en_TH,
            BABY_LOCALE.en_PH,
            BABY_LOCALE.en_ID,
            BABY_LOCALE.en_MY,
            BABY_LOCALE.en_VN,
        ],
    ],
    [LOCALE_SHORTCODE.nl_NL, [BABY_LOCALE.nl_BE]],
    [LOCALE_SHORTCODE.pt_BR, [BABY_LOCALE.pt]],
    [LOCALE_SHORTCODE.zh_TW, [BABY_LOCALE.zh_HK]],
    [LOCALE_SHORTCODE.fr_FR, [BABY_LOCALE.fr_BE, BABY_LOCALE.fr_CA, BABY_LOCALE.fr_CH, BABY_LOCALE.fr_LU]],
    [LOCALE_SHORTCODE.de_DE, [BABY_LOCALE.de_AT, BABY_LOCALE.de_CH, BABY_LOCALE.de_LU]],
    [LOCALE_SHORTCODE.it_IT, [BABY_LOCALE.it_CH]],
    [
        LOCALE_SHORTCODE.es_ES,
        [
            BABY_LOCALE.es_LA,
            BABY_LOCALE.es_MX,
            BABY_LOCALE.es_CL,
            BABY_LOCALE.es_AR,
            BABY_LOCALE.es_PE,
            BABY_LOCALE.es_CO,
        ],
    ],
]);

const LOCALE_SHORTCODE_NAME_MAPPING = new Map<LOCALE_SHORTCODE, string>([
    [LOCALE_SHORTCODE.ar_SA, 'Arabic'],
    [LOCALE_SHORTCODE.bg_BG, 'Bulgarian'],
    [LOCALE_SHORTCODE.bn_IN, 'Bengali'],
    [LOCALE_SHORTCODE.cs_CZ, 'Czech'],
    [LOCALE_SHORTCODE.cy_GB, 'Welsh'],
    [LOCALE_SHORTCODE.da_DK, 'Danish'],
    [LOCALE_SHORTCODE.de_DE, 'German'],
    [LOCALE_SHORTCODE.el_GR, 'Greek'],
    [LOCALE_SHORTCODE.en_US, 'English'],
    [LOCALE_SHORTCODE.es_ES, 'Spanish'],
    [LOCALE_SHORTCODE.et_EE, 'Estonian'],
    [LOCALE_SHORTCODE.fil_PH, 'Filipino'],
    [LOCALE_SHORTCODE.fi_FI, 'Finnish'],
    [LOCALE_SHORTCODE.fr_FR, 'French'],
    [LOCALE_SHORTCODE.he_IL, 'Hebrew'],
    [LOCALE_SHORTCODE.hi_IN, 'Hindi'],
    [LOCALE_SHORTCODE.hr_HR, 'Croatian'],
    [LOCALE_SHORTCODE.hu_HU, 'Hungarian'],
    [LOCALE_SHORTCODE.id_ID, 'Indonesian'],
    [LOCALE_SHORTCODE.it_IT, 'Italian'],
    [LOCALE_SHORTCODE.ja_JP, 'Japanese'],
    [LOCALE_SHORTCODE.ko_KR, 'Korean'],
    [LOCALE_SHORTCODE.lt_LT, 'Lithuanian'],
    [LOCALE_SHORTCODE.lv_LV, 'Latvian'],
    [LOCALE_SHORTCODE.mar_IN, 'Marathi'],
    [LOCALE_SHORTCODE.ms_MY, 'Malay'],
    [LOCALE_SHORTCODE.nb_NO, 'Norwegian'],
    [LOCALE_SHORTCODE.ne_NP, 'Nepali'],
    [LOCALE_SHORTCODE.nl_NL, 'Dutch'],
    [LOCALE_SHORTCODE.pl_PL, 'Polish'],
    [LOCALE_SHORTCODE.pt_BR, 'Portuguese'],
    [LOCALE_SHORTCODE.ro_RO, 'Romanian'],
    [LOCALE_SHORTCODE.ru_RU, 'Russian'],
    [LOCALE_SHORTCODE.sk_SK, 'Slovak'],
    [LOCALE_SHORTCODE.sr_BA, 'Serbian'],
    [LOCALE_SHORTCODE.sv_SE, 'Swedish'],
    [LOCALE_SHORTCODE.ta_IN, 'Tamil'],
    [LOCALE_SHORTCODE.tel_IN, 'Telugu'],
    [LOCALE_SHORTCODE.th_TH, 'Thai'],
    [LOCALE_SHORTCODE.tr_TR, 'Turkish'],
    [LOCALE_SHORTCODE.uk_UA, 'Ukrainian'],
    [LOCALE_SHORTCODE.vi_VN, 'Vietnamese'],
    [LOCALE_SHORTCODE.zh_CN, 'Simplified Chinese'],
    [LOCALE_SHORTCODE.zh_TW, 'Traditional Chinese'],
]);

export const TBW_UI_LOCALES: LOCALE_SHORTCODE[] = [
    LOCALE_SHORTCODE.cs_CZ,
    LOCALE_SHORTCODE.da_DK,
    LOCALE_SHORTCODE.de_DE,
    LOCALE_SHORTCODE.en_US,
    LOCALE_SHORTCODE.es_ES,
    LOCALE_SHORTCODE.fi_FI,
    LOCALE_SHORTCODE.fr_FR,
    LOCALE_SHORTCODE.hu_HU,
    LOCALE_SHORTCODE.id_ID,
    LOCALE_SHORTCODE.it_IT,
    LOCALE_SHORTCODE.ja_JP,
    LOCALE_SHORTCODE.ko_KR,
    LOCALE_SHORTCODE.nb_NO,
    LOCALE_SHORTCODE.nl_NL,
    LOCALE_SHORTCODE.pl_PL,
    LOCALE_SHORTCODE.pt_BR,
    LOCALE_SHORTCODE.sv_SE,
    LOCALE_SHORTCODE.ru_RU,
    LOCALE_SHORTCODE.th_TH,
    LOCALE_SHORTCODE.tr_TR,
    LOCALE_SHORTCODE.uk_UA,
    LOCALE_SHORTCODE.vi_VN,
    LOCALE_SHORTCODE.zh_CN,
    LOCALE_SHORTCODE.zh_TW,
];

// Locales which are specifically not supported by the Oxford APIs at the moment
const UNSUPPORTED_OXFORD_TAXONOMY_LOCALES = new Set([
    LOCALE_SHORTCODE.bn_IN,
    LOCALE_SHORTCODE.cy_GB,
    LOCALE_SHORTCODE.el_GR,
    LOCALE_SHORTCODE.fil_PH,
    LOCALE_SHORTCODE.hi_IN,
    LOCALE_SHORTCODE.ms_MY,
    LOCALE_SHORTCODE.ro_RO,
]);

export const getLocaleShortcodesArray = () => {
    return Object.values(LOCALE_SHORTCODE).filter((ls) => typeof ls === 'number') as LOCALE_SHORTCODE[];
};

export const isUnsupportedOxfordTaxonomyLocale = (locale: string): boolean => {
    try {
        const shortcodeExists = LOCALE_SHORTCODE[locale];
        if (shortcodeExists !== undefined) {
            return UNSUPPORTED_OXFORD_TAXONOMY_LOCALES.has(shortcodeExists);
        }
        return false;
    } catch {
        return false;
    }
};

export interface LocaleFilter {
    name: string;
    id: string;
}

/**
 * Returns an array of shortcode/name objects for localisation purposes
 * Ex.: [{ name: "Czech", id: "cs_CZ"}, { name: "Danish", id: "da_DK" }, ...].
 * Shortcodes which have no name mapping will be discarded.
 */
export const getLocalizationMapping = (localeShortcodes: LOCALE_SHORTCODE[]) => {
    const result: LocaleFilter[] = [];

    localeShortcodes.forEach((ele) => {
        const mapping = LOCALE_SHORTCODE_NAME_MAPPING.get(ele);
        if (mapping) result.push({ name: mapping, id: LOCALE_SHORTCODE[ele] });
    });

    return result;
};

export interface LanguageFilter {
    label: string;
    value: string;
}

/**
 * Returns an array of shortcode/name objects for filter dropdowns.
 * Ex.: [{ label: "Czech", value: "cs_CZ"}, { label: "Danish", value: "da_DK" }, ...].
 * Shortcodes which have no name mapping will be discarded.
 */
export const getLanguageList = (whitelist?: LOCALE_SHORTCODE[]) => {
    const result: LanguageFilter[] = [];

    // divide keys length by 2 due to enum double mapping
    for (let i = 0; i < Object.keys(LOCALE_SHORTCODE).length / 2; i++) {
        const mapping = LOCALE_SHORTCODE_NAME_MAPPING.get(i);
        if (mapping && (!whitelist || whitelist.includes(i)))
            result.push({ label: mapping, value: LOCALE_SHORTCODE[i] });
    }

    return result;
};

export const getBabyLocaleListForFilters = (parentLocale: string): { label: string; value: string }[] => {
    // In case that parentLocale is actually a baby geo locale itself, find it's parent instead
    const checkIfBabyLocale = findParentLocale(parentLocale);
    if (checkIfBabyLocale) {
        parentLocale = checkIfBabyLocale;
    }

    // Always add the parent locale itself to keep it selectable in the filters even if it has no baby geo locs
    const result = new Set<{ label: string; value: string }>();
    result.add({ label: parentLocale, value: parentLocale });

    // Test if baby geo locs exist for this parent locale and add them to the result set
    const babyLocales = BABY_LOCALE_PARENT_MAPPING.get(LOCALE_SHORTCODE[parentLocale]);
    if (babyLocales) {
        babyLocales.forEach((babyLocale) => {
            const enumKey = BABY_LOCALE[babyLocale];
            result.add({ label: enumKey, value: enumKey });
        });
    }

    return [...result];
};

export const findParentLocale = (locale: string) => {
    let result: string | null = null;
    BABY_LOCALE_PARENT_MAPPING.forEach((mapping, index) => {
        if (mapping.includes(BABY_LOCALE[locale])) {
            result = LOCALE_SHORTCODE[index];
        }
    });

    return result;
};
export const PL_CREATION_CREATIVE_FIELDS = [
    {
        id: 'c42a4f725de6414facbd08326ec4cc7f',
        internalId: 'graphic-design',
        enName: 'Graphic design',
        name: 'Graphic design',
        archived: false,
    },
    {
        id: '2d6f83ad13da4deb87b88905ea6dfffd',
        internalId: 'publishing',
        enName: 'Publishing',
        name: 'Publishing',
        archived: false,
    },
];

export const PL_CREATION_EXPERIENCE_LEVEL = [
    { id: 'beginner', name: 'Beginner' },
    { id: 'intermediate', name: 'Intermediate' },
    { id: 'intermediate-advanced', name: 'Advanced' },
];

export const PL_CREATION_SURFACE = [
    { id: 'in-app', name: 'In App' },
    { id: 'helpx', name: 'Helpx' },
    { id: 'education', name: 'Education' },
    { id: 'video-only', name: 'Video Only' },
    // { id: "low", name: "Learn on the Web" },
];
export const PL_CREATIVE_CATEGORY = [
    //TODO: Localization
    { id: 'nuj-orientation', name: 'Orientation' },
    { id: 'nuj-creative-effects', name: 'Creative Effects' },
    { id: 'graphic-design', name: 'Graphic Design' },
    { id: 'nuj-photo-editing', name: 'Photo Editing' },
];

export const getCreativeCategory = (id) => {
    const res = PL_CREATIVE_CATEGORY.filter((ele) => ele.id == id);
    return res[0]['name'];
};

export const CL_USE_CASE = [
    { id: 'Learning Path', name: 'Learning Path' },
    { id: 'Domain Curriculum', name: 'Domain Curriculum' },
];

export const getLanguage = (locale) => {
    const res = getLanguageList().filter((ele) => ele.value == locale);
    return res[0]?.label ?? '';
};

/**
 * Map Language dropdown value to locale code (e.g. "English" -> "en_US", "en_US" -> "en_US").
 * Use when piping the Language filter into auth or API calls that expect a locale.
 */
export const getLocaleFromLanguageDropdownValue = (languageDropdownValue: string): string => {
    if (!languageDropdownValue) return DEFAULT_LOCALE;

    const list = getLanguageList();
    const byValue = list.find((ele) => ele.value === languageDropdownValue);

    if (byValue) return byValue.value;

    const byLabel = list.find((ele) => ele.label === languageDropdownValue);
    return byLabel?.value ?? DEFAULT_LOCALE;
};

export const searchPerPageCountOptions = [
    { id: '12', name: '12' },
    { id: '24', name: '24' },
    { id: '48', name: '48' },
    { id: '100', name: '100' },
];

export const PL_ALL_TOPICS = allPlaylistTopics;
export const PL_CREATION_FIELDS = allPlaylistCreativeFields;

export const INPUT_STRING_SEARCH = 'lcp.common.search.placeholder';

export enum STATIC_DESCRIPTORS {
    STATUS = 'Status',
    APP = 'App',
    SURFACE = 'Surface',
    STAGE = 'Stage',
}

export enum PLAYLIST_STATUS {
    DRAFT = 'draft',
    ALL = 'all',
    LIVE = 'live',
}

export enum COLLECTION_STATUS {
    DRAFT = 'draft',
    ALL = 'all',
    LIVE = 'live',
}

export enum PLAYLIST_STAGE {
    NONE = 'none',
    ALL = 'all',
    NEW_IN_PROGRESS = 'New - in progress',
    NEW_PRODUCTION_READY = 'New - production ready',
    UPDATE_IN_PROGRESS = 'Update - in progress',
    UPDATE_PRODUCTION_READY = 'Update - production ready',
    FUTURE_UPDATE = 'Future update',
    REQUEST_ARCHIVE = 'Request - archive',
    ARCHIVED = 'Archived',
    DEPLOYED = 'Deployed',
}

export enum COLLECTION_STAGE {
    NONE = 'none',
    ALL = 'all',
    NEW_IN_PROGRESS = 'New - in progress',
    NEW_PRODUCTION_READY = 'New - production ready',
    UPDATE_IN_PROGRESS = 'Update - in progress',
    UPDATE_PRODUCTION_READY = 'Update - production ready',
    FUTURE_UPDATE = 'Future update',
    REQUEST_ARCHIVE = 'Request - archive',
    ARCHIVED = 'Archived',
    DEPLOYED = 'Deployed',
}

export const DISABLED_PLAYLIST_STAGES = new Set([PLAYLIST_STAGE.ARCHIVED, PLAYLIST_STAGE.DEPLOYED]);

export const DISABLED_COLLECTION_STAGES = new Set([COLLECTION_STAGE.ARCHIVED, COLLECTION_STAGE.DEPLOYED]);

export enum SURFACE {
    IN_APP = 'in-app',
    HELPX = 'helpx',
    EDUCATION = 'education',
    LOW = 'low',
    VIDEO_ONLY = 'video-only',
}

export const FILE_SIZE_LIMITS = {
    hero: {
        low: 750000,
        all: 300000,
    },
    thumbnail: {
        low: 300000,
        all: 200000,
    },
};

export const FILE_DIMENSION_LIMITS = {
    hero: {
        helpx: { width: 1000, height: 560 },
        // old value (dp?)
        // inapp: { height: 600, width: 1200 },
        dp: { width: 1200, height: 600 },
        dp_alt: { width: 1000, height: 560 },
        inapp: { width: 1000, height: 240 },
        inapp_alt: { width: 1920, height: 1080 },
        low: { width: 1920, height: 960 },
    },
    thumbnail: {
        helpx: { width: 297, height: 176 },
        // old value (dp?)
        // inapp: { height: 740, width: 740 },
        dp: { width: 740, height: 740 },
        dp_alt: { width: 297, height: 176 },
        inapp: { width: 952, height: 200 },
        inapp_alt: { width: 1920, height: 1080 },
        low: { width: 1200, height: 600 },
    },
    image_video: {
        all: { width: 560, height: 280 },
        all_big: { width: 1200, height: 600 },
    },
};

export const getMappedSurface = (surface = '', sap_code = '') => {
    if (surface === 'in-app' && ['PPRO', 'AEFT'].includes(sap_code)) {
        return 'dva';
    }
    if (surface === 'education') {
        return 'helpx';
    }
    return surface;
};

export const containsNoHelpUsingOrKB = (platformsArray) => {
    return platformsArray ? !(platformsArray.includes('help_using') || platformsArray.includes('help_kb')) : true;
};

export enum ADD_ELEMENT_DIALOGS {
    ADD_UTUT_ON_PLAYLIST_DETAILPAGE = 'ADD_UTUT_ON_PLAYLIST_DETAILPAGE',
    ADD_UTUT_TO_PLAYLIST_ON_UTUT_ACTIONBAR = 'ADD_UTUT_TO_PLAYLIST_ON_UTUT_ACTIONBAR',
    ADD_PLAYLIST_ON_COLLECTION_DETAILPAGE = 'ADD_PLAYLIST_ON_COLLECTION_DETAILPAGE',
}

const _mapLegacySections = (collection) => {
    const sections: Section[] = [];

    if (collection['playlist_metadata'] && Array.isArray(collection['playlist_metadata'])) {
        collection['playlist_metadata'].forEach((playlist) => {
            const sectionAlreadyExists = sections.findIndex((section) => {
                return section.title === playlist.section;
            });

            if (sectionAlreadyExists !== -1) {
                sections[sectionAlreadyExists]['items'].push({
                    id: playlist.aem_id,
                    type: 'playlist',
                });
            } else {
                sections.push({
                    id: getSanitizedIdFromTitle(playlist.section),
                    title: playlist.section,
                    items: [
                        {
                            id: playlist.aem_id,
                            type: 'playlist',
                        },
                    ],
                });
            }
        });
    }

    return sections;
};

export const mapCollectionSections = (collection) => {
    const collectionCopy = JSON.parse(JSON.stringify(collection));

    // map legacy collection sections to the new schema
    if (!collectionCopy['sections'] && collectionCopy['playlist_metadata']) {
        collectionCopy.sections = _mapLegacySections(collectionCopy);
    }

    if (!collectionCopy.sections || collectionCopy.sections.length === 0) {
        collectionCopy.sections = [_getDefaultSection()];
    }

    const playlists = collectionCopy['playlist_metadata'];
    // fix issues with draft collections when having both draft and live version of a playlist
    if (!playlists) {
        collectionCopy['sections'] = [];
        collectionCopy['playlist_ids'] = [];
        return collectionCopy;
    }

    let tutorialSortId = 1;
    playlists.forEach((playlist) => {
        let hit = false;
        collectionCopy['sections'].forEach((section) => {
            section['items'].forEach((sectionPlaylist) => {
                if (
                    !hit &&
                    playlist.aem_id === sectionPlaylist.id &&
                    playlist.section === section.title &&
                    !sectionPlaylist['_metadata']
                ) {
                    sectionPlaylist['_metadata'] = playlist;
                    sectionPlaylist['_metadata']['_sortId'] = tutorialSortId;
                    tutorialSortId++;
                    hit = true;
                }
            });
        });
    });

    return collectionCopy;
};

export const mapPlaylistSections = (playlist) => {
    const playlistCopy = JSON.parse(JSON.stringify(playlist));

    // different from collections, sections are optional for playlists, do not create a sections object if there isn't already
    if (!playlistCopy.sections) {
        return null;
    }

    const ututs = playlistCopy['utut_metadata'];
    playlistCopy['sections'].forEach((section) => {
        if (section['items']) {
            section['items'].forEach((sectionUtut) => {
                sectionUtut['_metadata'] = ututs.find((pl) => pl.aem_id === sectionUtut['id']);
            });
        }
    });

    return playlistCopy;
};

const _getDefaultSection = () => {
    const title = 'Section 1';
    return {
        id: getSanitizedIdFromTitle(title) + '_' + _makeid(12),
        items: [],
        title: title,
    };
};

const _makeid = (length) => {
    let result = '';
    const characters = 'abcdefghijklmnopqrstuvwxyz';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
};

export const getSanitizedIdFromTitle = (title) => {
    const sanitizedId = title.toLowerCase().replace(/[^a-z]/gi, '_');
    return sanitizedId + '_' + _makeid(12);
};

export const updateSortOrder = (newElements) => {
    const elements = JSON.parse(JSON.stringify(newElements));
    let sortId = 1;
    for (let i = 0; i < elements.length; i++) {
        const section = elements[i];
        const data = [...(section?.items ?? [])];
        for (let j = 0; j < data.length; j++) {
            data[j]['_metadata']['_sortId'] = sortId;
            sortId++;
        }
        elements[i].items = [...data];
    }
    return elements;
};

export const sanitizePlaylistHeaderValues = (item) => {
    if (!item) return;

    if (item.primary_sap_code) item.app = item.primary_sap_code;
    if (item.playlist_stage) item.stage = item.playlist_stage;
    if (item.platforms) item.surface = sanitizePlaylistHeaderSurface(item.platforms);
    if (item.thumbnail) item.heroImage = item.thumbnail;

    return item;
};

export const sanitizePlaylistHeaderSurface = (surfaces: string[]): string => {
    // For display purposes, only show a single surface with the following priority
    if (!surfaces || !surfaces.length) return '';

    if (surfaces.includes('in-app')) return 'in-app';
    if (surfaces.includes('helpx')) return 'helpx';
    if (surfaces.includes('education')) return 'education';
    if (surfaces.length > 0) return surfaces[0];

    return '';
};

export const _cleanPlaylistCollectionMetadata = (playlist) => {
    const obj = {};
    obj['aem_id'] = playlist?._metadata?.aem_id;
    obj['appCode'] = playlist?._metadata?.sap_code ? playlist?._metadata?.sap_code[0] : '';
    obj['locale'] = playlist?._metadata?.locale;
    obj['modifiedOn'] = playlist?._metadata?.modified_on;
    obj['status'] = playlist?._metadata?.status;
    obj['playlist_stage'] = playlist?._metadata?.playlist_stage;
    obj['platforms'] = playlist?._metadata?.platforms;
    obj['surface'] = playlist?._metadata?.platforms
        ? playlist?._metadata?.platforms.includes('in-app')
            ? 'in-app'
            : playlist?._metadata?.platforms.includes('helpx')
              ? 'helpx'
              : playlist?._metadata?.platforms.length > 0
                ? playlist?._metadata?.platforms[0]
                : ''
        : '';
    obj['thumbnail'] = playlist?._metadata?.thumbnail;
    obj['title'] = playlist?._metadata?.title;
    obj['_sortId'] = playlist?._metadata?._sortId;

    return obj;
};

export const _cleanTutorialMetadata = (sourceUtut, additionalKey?: Record<string, unknown>) => {
    let cleanUtut = {};

    cleanUtut['aem_id'] = sourceUtut?.aem_id;
    cleanUtut['url'] = sourceUtut?.helpx_url ?? '';
    cleanUtut['appCode'] = sourceUtut?.sap_code;
    cleanUtut['locale'] = sourceUtut?.locale;
    cleanUtut['modifiedOn'] = sourceUtut?.modified_on;
    cleanUtut['status'] = sourceUtut?.status;
    cleanUtut['platforms'] = sourceUtut?.platforms;
    cleanUtut['surface'] = sourceUtut?.platforms.includes('in-app')
        ? 'in-app'
        : sourceUtut?.platforms.includes('helpx')
          ? 'helpx'
          : sourceUtut?.platforms.includes('education')
            ? 'education'
            : '';
    cleanUtut['thumbnail'] = sourceUtut?.thumbnail;
    cleanUtut['title'] = sourceUtut?.title;

    if (additionalKey) {
        cleanUtut = { ...cleanUtut, ...additionalKey };
    }

    return cleanUtut;
};

export interface Section {
    id: string;
    title: string;
    items: SectionElement[];
}

export interface SectionElement {
    id: string;
    type: string;
    _metadata?: [];
}

export const validateDuplicatedElements = (duplicatedElements) => {
    let sortId = 1;

    const validElements: any = [];
    const invalidElements: any = [];

    duplicatedElements.forEach((duplicatedElement) => {
        if (duplicatedElement?.res.length !== 0) {
            const element = duplicatedElement.res[0];
            element['aem_id'] = element['aemId'];
            element['sortId'] = sortId;
            delete element['aemId'];
            validElements.push(element);
            sortId++;
        } else {
            invalidElements.push(duplicatedElement);
        }
    });

    return { validElements: validElements, invalidElements: invalidElements };
};

export const orderAndValidateDuplicatedElements = (sourceElements, duplicatedElements) => {
    let sortId = 1;
    const validElements: any = [];
    const invalidElements: any = [];

    sourceElements.forEach((sourceUtut) => {
        const matchedDuplicatedElement = duplicatedElements.filter(function (element) {
            return element['aem_id'] == sourceUtut['aem_id'] && element['status'] == sourceUtut['status'];
        });

        if (matchedDuplicatedElement.length && matchedDuplicatedElement[0]?.res.length !== 0) {
            const element = matchedDuplicatedElement[0]?.res[0];
            element['aem_id'] = element['aemId'];
            element['sortId'] = sortId;
            delete element['aemId'];
            validElements.push(element);
            sortId++;
        } else {
            invalidElements.push(sourceUtut);
        }
    });

    return { validElements: validElements, invalidElements: invalidElements };
};

export const orderAndValidateDuplicatedSections = (sourceResponse, duplicatedElements, type) => {
    if (sourceResponse.length === 0 || (type !== ELEMENT_TYPES.COLLECTION && type !== ELEMENT_TYPES.PLAYLIST)) {
        return { validElements: [], invalidElements: [], validSections: [] };
    }

    let sortId = 1;
    const validElements: any = [];
    const invalidElements: any = [];
    const validSections: Section[] = [];

    let sourceSections =
        type === ELEMENT_TYPES.COLLECTION
            ? mapCollectionSections(sourceResponse[0])
            : mapPlaylistSections(sourceResponse[0]);

    sourceSections = sourceSections.sections;

    sourceSections.forEach((sourceSection) => {
        const validSectionElements: SectionElement[] = [];

        sourceSection.items.map((sourceElement) => {
            const matchedDuplicatedElement = duplicatedElements.filter(function (element) {
                return element['aem_id'] == sourceElement['id'];
            });

            if (matchedDuplicatedElement.length && matchedDuplicatedElement[0]?.res.length !== 0) {
                const element = matchedDuplicatedElement[0]?.res[0];

                element['aem_id'] = element['aemId'];
                element['sortId'] = sortId;
                delete element['aemId'];

                validElements.push(element);

                let sectionEle = JSON.parse(JSON.stringify(element));
                sectionEle['_sortId'] = sortId;
                delete sectionEle['sortId'];

                sectionEle = {
                    id: sectionEle['aem_id'],
                    type: type === ELEMENT_TYPES.COLLECTION ? ELEMENT_TYPES.PLAYLIST : ELEMENT_TYPES.TUTORIAL,
                    _metadata: sectionEle,
                };

                validSectionElements.push(sectionEle);
                sortId++;
            } else {
                invalidElements.push({
                    aem_id: sourceElement._metadata['aem_id'],
                    status: sourceElement._metadata['status'],
                });
            }
        });

        validSections.push({
            id: sourceSection.id,
            title: sourceSection.title,
            items: validSectionElements,
        });
    });

    return { validElements: validElements, invalidElements: invalidElements, validSections: validSections };
};

export const filterLineBreaks = (value: string): string => {
    return value ? value.replaceAll(/(\r\n|\n|\r)/gm, '') : value;
};
